import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CypressGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean> {
    const windowObject: any = window;

    if (windowObject.Cypress) {
      return of(true);
    } else {
      this.router.navigateByUrl(`/`);
    }
  }
}
